import React, { useEffect, useState } from "react";
import { useUpdateEffect } from "react-use";
import Icon from "./Icon";

const Toast = ({ ms, show, type, text, onClose }) => {
  // eslint-disable-next-line no-unused-vars
  const [timer, setTimer] = useState(null);
  const [style, setStyle] = useState("");

  const handleClose = () => {
    onClose();
    setTimer(null);
  };

  useEffect(() => {
    if (type === "error") {
      setStyle("bg-red-400 text-white");
    } else if (type === "warning") {
      setStyle("bg-orange-500 text-base");
    } else if (type === "success") {
      setStyle("alert-success");
    } else {
      setStyle("alert-info");
    }
  }, [type]);

  useUpdateEffect(() => {
    if (show) {
      const id = setTimeout(() => {
        handleClose();
      }, ms);
      setTimer(id);
    }
  }, [show]);

  return (
    <>
      {show && (
        <div
          className={`${show ? "toast " : ""}toast-end`}
          onClick={handleClose}
        >
          <div className={`alert ${style}`}>
            <div className="inline-flex align-middle justify-center pl-4 pr-8">
              {type === "error" && <Icon name="xclamation-circle" />}
              {type === "warning" && <Icon name="exclamation-triangle" />}
              {type === "info" && <Icon name="information-circle" />}
              <span>{text}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Toast;
